import React, {useEffect, useState} from 'react';
import AppContainer from "../components/AppContainer";
import AdminSidebar from "../components/admin/AdminSidebar";
import {useNavigate, useParams} from "react-router-dom";
import AdminConcerts from "../components/admin/AdminConcerts";
import AdminArticles from "../components/admin/AdminArticles";
import AdminUsers from "../components/admin/AdminUsers";
import {ACCESS_TOKEN_KEY} from "../constants/constants";
import axios from "axios";
import opsToast from "../ops-library/ops-toast";
import {isTokenExpired} from "../functions/isTokenExpired";
import {LoadingSpinner} from "../components/LoadingSpinner";
import {sections} from "../functions/sections";
import OpsText from "../ops-library/ops-text";
import AdminProducts from "../components/admin/AdminProducts";
import AdminOrders from "../components/admin/AdminOrders";
import AdminGallery from "../components/admin/AdminGallery";
import AdminInformations from "../components/admin/AdminInformations";
import AdminReviews from "../components/admin/AdminReviews";

const AdminPanel = () => {
    const token = localStorage.getItem(ACCESS_TOKEN_KEY);
    const navigate = useNavigate()
    const [webData, setWebData] = useState();
    const [logged, setLogged] = useState();
    const {adminSection} = useParams()
    const [theme, setTheme] = useState(
        localStorage.getItem("theme") != null ? localStorage.getItem("theme") : "light"
    );

    useEffect(() => {
        if (!isTokenExpired(token)) {
            getLoggedUser();
        } else {
            setLogged(null);
            navigate("/")
        }
    }, []);

    function getLoggedUser() {
        const configuration = {
            method: "get",
            url: `${process.env.REACT_APP_API_BASE_URL}/auth/profile`,
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        axios(configuration)
            .then((result) => {
                const user_id = result.data.user_id
                const configuration2 = {
                    method: "get",
                    url: `${process.env.REACT_APP_API_BASE_URL}/auth/userInfo/${user_id}`,
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                };
                axios(configuration2)
                    .then((result) => {
                        setLogged(result.data.userInfo)
                        getWebData()
                    })
                    .catch((error) => {
                        console.log(error)
                        opsToast(error.response?.data?.message, "error", "colored", true, "top-center");
                    });


            })
            .catch((error) => {
                console.log(error)
                opsToast(error.response?.data?.message, "error", "colored", true, "top-center");
            });
    }


    function getWebData() {
        const configuration = {
            method: "get",
            url: `${process.env.REACT_APP_API_BASE_URL}/webdata`,
        };

        axios(configuration)
            .then((result) => {
                setWebData(result.data.content)
            })
            .catch((error) => {
                opsToast(error.response?.data?.message, "error", "colored", true, "top-center");
                navigate("/")
            });
    }

    return (
        logged !== undefined && webData !== undefined ?
            <AppContainer
                showFooter={false}
                showSlides={false}
                showNavbar={false}
                content={
                    <div className="window-admin-container">
                        {/* TO DO: pridat zobrazenie podla roli aj do kazdej podstranky pre osetrenie pristupu! */}
                        <AdminSidebar roles={sections} theme={theme} webDatas={webData} user={logged} token={token}/>
                        {adminSection === undefined &&
                            <div className="fa-flex-col fa-w-100 align-items-center justify-content-center p-2 gap-1">
                                <OpsText type="subtitle fa-w-100" weight={600}
                                         content="ADMIN PANEL"/>
                                <OpsText type="normal fa-w-100" weight={400}
                                         content="Pre nastavenie rôznych súčastí aplikácie vyberte niektorú kategóriu z bočného panelu vľavo."/>
                            </div>
                        }
                        {adminSection === 'koncerty' &&
                            <AdminConcerts theme={theme} webDatas={webData} user={logged} token={token}
                                           sectionId='koncerty'
                                           roles={sections.find((section) => section.sectionId === 'koncerty').rolesList}
                            />}
                        {adminSection === 'informacie' &&
                            <AdminInformations theme={theme} webDatas={webData} user={logged} token={token}
                                               sectionId='informacie'
                                               roles={sections.find((section) => section.sectionId === 'informacie').rolesList}
                            />}
                        {adminSection === 'objednavky' &&
                            <AdminOrders theme={theme} webDatas={webData} user={logged} token={token}
                                         sectionId='objednavky'
                                         roles={sections.find((section) => section.sectionId === 'objednavky').rolesList}
                            />}
                        {adminSection === 'produkty' &&
                            <AdminProducts theme={theme} webDatas={webData} user={logged} token={token}
                                           sectionId='produkty'
                                           roles={sections.find((section) => section.sectionId === 'produkty').rolesList}
                            />}
                        {adminSection === 'aktuality' &&
                            <AdminArticles theme={theme} webDatas={webData} user={logged} token={token}
                                           sectionId='aktuality'
                                           roles={sections.find((section) => section.sectionId === 'aktuality').rolesList}
                            />}
                        {adminSection === 'recenzie' &&
                            <AdminReviews theme={theme} webDatas={webData} user={logged} token={token}
                                          sectionId='recenzie'
                                          roles={sections.find((section) => section.sectionId === 'recenzie').rolesList}
                            />}
                        {adminSection === 'galeria' &&
                            <AdminGallery theme={theme} webDatas={webData} user={logged} token={token}
                                          sectionId='galeria'
                                          roles={sections.find((section) => section.sectionId === 'galeria').rolesList}
                            />}

                        {/*SYSTEM*/}
                        {adminSection === 'webApp-manazment' &&
                            <AdminUsers theme={theme} user={logged} token={token}
                                        sectionId='webApp-manazment'
                                        roles={sections.find((section) => section.sectionId === 'webApp-manazment').rolesList}
                            />}
                    </div>
                }
            />
            :
            <AppContainer
                content={
                    <div className="window-content-container justify-content-center h-100 w-100">
                        <LoadingSpinner/>
                    </div>
                }
            />
    );
};

export default AdminPanel;